import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * @file Created on Thu Aug 16 2018
 * @author VBr
 */
import translate from '../../../../components/i18n/translate';
import { RendererNames } from '../components/renderers';
export var ActionsGenerator =
/*#__PURE__*/
function () {
  function ActionsGenerator() {
    _classCallCheck(this, ActionsGenerator);
  }

  _createClass(ActionsGenerator, [{
    key: "getColumnDefinition",
    value: function getColumnDefinition(colDef) {
      return Object.assign({
        headerName: translate(colDef ? colDef.headerName || 'actions' : 'actions'),
        cellRenderer: RendererNames.ActionsRenderer,
        field: 'actions',
        lockVisible: true,
        suppressMenu: true,
        lockPinned: true,
        sortable: false,
        suppressMovable: true,
        filter: false,
        suppressNavigable: true,
        // resizable: false, // LOG-3237
        headerCheckboxSelectionFilteredOnly: true,
        headerCheckboxSelection: true,
        suppressSizeToFit: true,
        // width: 110, // LOG-5371
        pinned: 'left',
        checkboxSelection: true,
        excel: {
          hide: true
        }
      }, colDef);
    }
  }, {
    key: "getColumnData",
    value: function getColumnData() {
      for (var _len = arguments.length, actions = new Array(_len), _key = 0; _key < _len; _key++) {
        actions[_key] = arguments[_key];
      }

      return {
        actions: actions
      };
    }
  }]);

  return ActionsGenerator;
}();